import { useUtility } from '@highq/frontend-utility'
import INJECTION_KEYS from '@injectionKeys'
import Session from '@lib/session.js'
import { reactive } from 'vue'


/** @type {GlobalState} */
const globalState = reactive({
    baseData: undefined,
    requiredFields: undefined,
    isLoading: false,
    isRequired: (key) => !!useUtility().toolkit.deepGetProperty(globalState.requiredFields, key)
})

/** @type {Session} */
const sessionState = reactive(new Session())

const SNACK_LEVEL = {
    INFO: 'info',
    WARNING: 'warning',
    SUCCESS: 'success',
    ERROR: 'error'
}

/** @type {SnackState} */
const snackState = reactive({
    timeout: 3000,
    position: 'bottom',
    show: false,
    snack: undefined,

    showSnack: (message, level) => {
        snackState.snack = { message, level }
        snackState.show = true
    },
    showErrorSnack: (message) => snackState.showSnack(message, SNACK_LEVEL.ERROR),
    showWarningSnack: (message) => snackState.showSnack(message, SNACK_LEVEL.WARNING ),
    showInfoSnack: (message) => snackState.showSnack(message, SNACK_LEVEL.INFO),
    showSuccessSnack: (message) => snackState.showSnack(message, SNACK_LEVEL.SUCCESS),
})


const AppState = {
    install(app) {
        app.provide(INJECTION_KEYS.GLOBALSTATE, globalState)
        app.provide(INJECTION_KEYS.SESSIONSTATE, sessionState)
        app.provide(INJECTION_KEYS.SNACKSTATE, snackState)
    }
}

export {
    globalState,
    sessionState,
    SNACK_LEVEL,
    snackState
}

export default AppState